import { FunctionComponentType } from '@interfaces/commons/FunctionComponent'

export enum TabModeEnum {
  LINE = 'line',
  BOX = 'box',
}

export interface TabContextType {
  activeTab: string
  mode: TabModeEnum
  handleUpdateActiveTab: (key: string) => void
  handleTabNameChange: (tabId: string, tabName: string) => void
}

export interface TabType {
  tabId: string
  name: string
  dataTest?: string
}

export interface TabsProviderProps extends FunctionComponentType {
  className?: string
  borderBottomClassName?: string
  id?: string
  mode?: TabModeEnum
  initialTabs: TabType[]
  onActiveTabChange?: (key: string) => void
  isFirstTabMargin?: boolean
}
